// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2qmO4","inner":"Form_inner__1EIWM","range":"Form_range__vwEIJ","name":"Form_name__1fk1g","actions":"Form_actions__3wcFw"};